import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputMui } from '../../../../../../components/input-mui/input-mui';

type EmailProps = {
  disabled?: boolean;
};

export const Email: React.FC<EmailProps> = ({ disabled = false }) => {
  const { control } = useFormContext();
  const { t } = useTranslation('installation');
  const { t: tc } = useTranslation('common');

  return (
    <Controller
      name="email"
      control={control}
      rules={{
        required: {
          value: true,
          message: tc('isRequired'),
        },
      }}
      render={({ field, fieldState: { error } }) => (
        <InputMui
          disabled={disabled}
          value={field.value}
          label={t('exalus.email')}
          onChange={field.onChange}
          {...(error ? { errorMessage: error.message } : {})}
        />
      )}
    />
  );
};
